import avatar from '../src/assets/images/tutor.png';
import header from '../src/assets/images/tutor-header.svg';

import slide1 from '../src/assets/images/intro-1.jpg';
import slide2 from '../src/assets/images/intro-2.jpg';
import slide3 from '../src/assets/images/intro-3.jpg';
import slide4 from '../src/assets/images/intro-4.jpg';

import typesofcomms from '../src/assets/images/types-of-comm.jpg';

import evolution1 from '../src/assets/images/Communication Evolution Timeline (9).JPG';
import evolution2 from '../src/assets/images/Communication Evolution Timeline (10).JPG';
import evolution3 from '../src/assets/images/Communication Evolution Timeline (11).JPG';
import evolution4 from '../src/assets/images/Communication Evolution Timeline (12).JPG';
import evolution5 from '../src/assets/images/Communication Evolution Timeline (13).JPG';

import digitalComm from '../src/assets/images/digital-comm.JPG';

export const tutors = [
  {
    id: 1,
    first_name: 'Nnnena Okore',
    summary:
      'Nnenna Okore is a qualified turor with over 6 year of teaching experience in mathematics, futher mathematic and arithmetics',
    lessons_count: 3,
    courses_count: 3,
    location: 'Lagos,Nigeria',
    avatar: avatar,
    banner: header,
    subjects: [
      {
        id: 1,
        title: 'Communication',
        description:
          'Evolution is the process by which diffrent kinds of living organisms are believed to have developed from earlier forms during the history of the earth',
        banner:
          'http://images.shiksha.com/mediadata/images/articles/1538985491phpKctLgx.jpeg',
        duration: '3 months',
        lesson_style: 'Teacher Led',
        language: 'English',
        lessons_count: 2,
        features: [
          {
            description: 'Introduction to evolution of communication',
          },
          {
            description: 'Communication Evolution',
          },
          {
            description: 'Digital Communication',
          },
        ],
        units: [
          {
            id: 1,
            sn: '2.0',
            description: 'Intro to evolution of communication',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 2,
                sn: '2.0.1',
                description: 'Intro to evolution of communication(1)',
                duration: '00:03:00',
                type: 'picture',
                file_location: slide1,
                duration_in_words: '3 minutes',
              },
              {
                id: 3,
                sn: '2.0.1',
                description: 'Intro to evolution of communication(2)',
                duration: '00:03:00',
                type: 'picture',
                file_location: slide2,
                duration_in_words: '3 minutes',
              },
              {
                id: 4,
                sn: '2.0.1',
                description: 'Intro to evolution of communication(3)',
                duration: '00:03:00',
                type: 'picture',
                file_location: 'http://demo.edves.net',
                duration_in_words: '3 minutes',
              },
            ],
          },
          {
            id: 2,
            sn: '3.0',
            description: 'Types of communication',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 1,
                sn: '3.0.1',
                description: 'Types of communication',
                duration: '00:03:00',
                type: 'picture',
                file_location: 'http://demo.edves.net',
                duration_in_words: '3 minutes',
              },
            ],
          },
        ],
      },

      {
        id: 2,
        title: 'Summary Writing (English)',
        description:
          'Summary wrtiting teaches students how to write summary,Summary wrtiting teaches students how to write summary,Summary wrtiting teaches students how to write summary',
        banner:
          'http://images.shiksha.com/mediadata/images/articles/1538985491phpKctLgx.jpeg',
        duration: '3 months',
        lesson_style: 'Teacher Led',
        language: 'English',
        lessons_count: 2,
        features: [
          {
            description: 'Summary Writing Intro',
          },
          {
            description: 'Summary Writing Lesson 1',
          },
          {
            description: 'Summary Writing Lesson 2',
          },
          {
            description: 'Summary Writing Lesson 3',
          },
        ],
        units: [
          {
            id: 1,
            sn: '1.0',
            description: 'Summary Writing Intro',
            course_id: 1,
            lessons_count: 1,
            duration: '1 minutes',
            lessons: [
              {
                id: 1,
                sn: '1.0.1',
                description: 'Summary Writing Intro',
                duration: '00:00:48',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663683608/pl/Summary_Writing_Lesson_1_jjyx5x.mp4',
                duration_in_words: '1 minute',
              },
            ],
          },
          {
            id: 2,
            sn: '2.0',
            description: 'Summary Writing Lesson 1',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 1,
                sn: '2.0.1',
                description: 'Summary Writing Lesson 1',
                duration: '00:04:53',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663683608/pl/Summary_Writing_Lesson_1_jjyx5x.mp4',
                duration_in_words: '5 minutes',
              },
            ],
          },

          {
            id: 3,
            sn: '3.0',
            description: 'Summary Writing Lesson 2',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 2,
                sn: '3.0.1',
                description: 'Summary Writing Lesson 2',
                duration: '00:07:27',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663683913/pl/Summary_Writing_Lesson_2_m495qv.mp4',
                duration_in_words: '7 minutes',
              },
            ],
          },

          {
            id: 4,
            sn: '4.0',
            description: 'Summary Writing Lesson 3',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 2,
                sn: '4.0.1',
                description: 'Summary Writing Lesson 3',
                duration: '00:07:11',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663684529/pl/Summary_Writing_Lesson_3_h7rqbx.mp4',
                duration_in_words: '7 minutes',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    first_name: 'Kehinde Olorunfemi',
    summary:
      'Kehinde Olorunfemi is a qualified turor with over 4 year of teaching experience in mathematics, futher mathematic and arithmetics',
    lessons_count: 3,
    courses_count: 3,
    location: 'Lagos,Nigeria',
    avatar: avatar,
    banner: header,
    subjects: [
      {
        id: 1,
        title: 'Genetics (Biology)',
        description:
          'Evolution is the process by which diffrent kinds of living organisms are believed to have developed from earlier forms during the history of the earth',
        banner:
          'http://images.shiksha.com/mediadata/images/articles/1538985491phpKctLgx.jpeg',
        duration: '3 months',
        lesson_style: 'Teacher Led',
        language: 'English',
        lessons_count: 2,
        features: [
          {
            description: 'Introduction to genetics',
          },
          {
            description: 'Terms used in genetics',
          },
          {
            description: 'Mendels contributions to genetics',
          },
          {
            description: 'Genetics Questions',
          },
        ],
        units: [
          {
            id: 4,
            sn: '2.0',
            description: 'Introduction to genetics',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 2,
                sn: '2.0.1',
                description: 'Genetics',
                duration: '00:03:00',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663688747/pl/1.1.1__Genetics_i7b4mu.mp4',
                duration_in_words: '3 minutes',
              },
              {
                id: 3,
                sn: '2.0.1',
                description: 'Transmittable Characters in Humans and Plants',
                duration: '00:03:00',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663688799/pl/1.1.2__Transmittable_Characters_in_Humans_and_Plants_x9kwck.mp4',
                duration_in_words: '3 minutes',
              },
            ],
          },
          {
            id: 5,
            sn: '3.0',
            description: 'Terms used in genetics',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 1,
                sn: '3.0.1',
                description: 'Terms used in genetics 1',
                duration: '00:06:00',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663688950/pl/Terms_Used_in_Genetics_1_mhgr1p.mp4',
                duration_in_words: '6 minutes',
              },
              {
                id: 2,
                sn: '3.0.2',
                description: 'Terms used in genetics 2',
                duration: '00:07:30',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663689215/pl/Terms_Used_in_Genetics_2_hrrmzu.mp4',
                duration_in_words: '7 minutes',
              },
              {
                id: 3,
                sn: '3.0.3',
                description: 'Terms used in genetics 3',
                duration: '00:05:22',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663689296/pl/Terms_Used_in_Genetics_3_htvync.mp4',
                duration_in_words: '5 minutes',
              },
              {
                id: 4,
                sn: '3.0.4',
                description: 'Terms used in genetics 4',
                duration: '00:06:08',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663689402/pl/Terms_Used_in_Genetics_4_flgaop.mp4',
                duration_in_words: '6 minutes',
              },
            ],
          },

          {
            id: 6,
            sn: '4.0',
            description: 'Mendels contributions to genetics',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 2,
                sn: '4.0.1',
                description: 'Mendels work in genetics',
                duration: '00:07:27',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663689578/pl/Mendel_s_Work_in_Genetics_pvbzhg.mp4',
                duration_in_words: '7 minutes',
              },
            ],
          },

          {
            id: 7,
            sn: '5.0',
            description: 'Genetics Questions',
            course_id: 1,
            lessons_count: 1,
            duration: '3 minutes',
            lessons: [
              {
                id: 1,
                sn: '5.0.1',
                description: 'Genetics Questions',
                duration: '00:08:57',
                type: 'video',
                file_location:
                  'https://res.cloudinary.com/dzpqw6eo3/video/upload/v1663689649/pl/Genetic_problems_uepuba.mp4',
                duration_in_words: '9 minutes',
              },
            ],
          },
        ],
      },
    ],
  },
];

export const singleSubject = [];
export const learnSubject = {
  id: 5,
  title: 'Communication',
  description:
    'The modules are the train K-12 children on the evolution of communication and the the different form. To encourage them to be more aware of their environment and acquire communication skills required to thrive in todays world.',
  banner:
    'http://images.shiksha.com/mediadata/images/articles/1538985491phpKctLgx.jpeg',
  duration: '30 mins',
  lesson_style: 'Teacher Led',
  language: 'English',
  lessons_count: 2,
  features: [
    {
      description: 'Introduction to evolution of communication',
    },
    {
      description: 'Communication Evolution',
    },
    {
      description: 'Digital Communication',
    },
  ],
  units: [
    {
      id: 4,
      sn: '1.0',
      description: 'Intro to evolution of communication',
      course_id: 1,
      lessons_count: 1,
      duration: '3 minutes',
      lessons: [
        {
          id: 2,
          sn: '1.0.1',
          description: 'Intro to evolution of communication(1)',
          duration: '00:03:00',
          type: 'picture',
          file_location: slide1,
          duration_in_words: '3 minutes',
        },
        {
          id: 3,
          sn: '1.0.2',
          description: 'Intro to evolution of communication(2)',
          duration: '00:03:00',
          type: 'picture',
          file_location: slide2,
          duration_in_words: '3 minutes',
        },
        {
          id: 4,
          sn: '1.0.3',
          description: 'Intro to evolution of communication(3)',
          duration: '00:03:00',
          type: 'picture',
          file_location: slide3,
          duration_in_words: '3 minutes',
        },
        {
          id: 5,
          sn: '1.0.4',
          description: 'Intro to evolution of communication(3)',
          duration: '00:03:00',
          type: 'picture',
          file_location: slide4,
          duration_in_words: '3 minutes',
        },
      ],
    },
    {
      id: 5,
      sn: '2.0',
      description: 'Types of communication',
      course_id: 1,
      lessons_count: 1,
      duration: '3 minutes',
      lessons: [
        {
          id: 2,
          sn: '2.0.1',
          description: 'Types of communication',
          duration: '00:03:00',
          type: 'picture',
          file_location: typesofcomms,
          duration_in_words: '3 minutes',
        },
      ],
    },

    {
      id: 6,
      sn: '3.0',
      description: 'Evolution of communication',
      course_id: 1,
      lessons_count: 1,
      duration: '3 minutes',
      lessons: [
        {
          id: 2,
          sn: '2.0.1',
          description: 'Evolution of communication (1)',
          duration: '00:03:00',
          type: 'picture',
          file_location: evolution1,
          duration_in_words: '3 minutes',
        },

        {
          id: 3,
          sn: '2.0.2',
          description: 'Evolution of communication (2)',
          duration: '00:03:00',
          type: 'picture',
          file_location: evolution2,
          duration_in_words: '3 minutes',
        },
        {
          id: 3,
          sn: '2.0.3',
          description: 'Evolution of communication (3)',
          duration: '00:03:00',
          type: 'picture',
          file_location: evolution3,
          duration_in_words: '3 minutes',
        },
        {
          id: 4,
          sn: '2.0.4',
          description: 'Evolution of communication (4)',
          duration: '00:03:00',
          type: 'picture',
          file_location: evolution4,
          duration_in_words: '3 minutes',
        },
        {
          id: 5,
          sn: '2.0.5',
          description: 'Evolution of communication (5)',
          duration: '00:03:00',
          type: 'picture',
          file_location: evolution5,
          duration_in_words: '3 minutes',
        },
      ],
    },

    {
      id: 6,
      sn: '3.0',
      description: 'Digital Communication',
      course_id: 1,
      lessons_count: 1,
      duration: '3 minutes',
      lessons: [
        {
          id: 2,
          sn: '2.0.1',
          description: 'Digital Communication',
          duration: '00:03:00',
          type: 'picture',
          file_location: digitalComm,
          duration_in_words: '3 minutes',
        },
      ],
    },
  ],
};

export const slides = [
  {
    id: 1,
    img: slide1,
  },
];

export const liveClasses = [
  {
    id: 1,
    title: 'Memorize the periodic table in 5 mins ',
    subtitle: 'Introduction to periodic table',
    when: 'Happening Now',
    time: '9:00am - 10:00am',
  },

  {
    id: 2,
    title: 'Linear equation made easy',
    subtitle: 'History of linear equation, What is linear equation',
    when: 'Today',
    time: '12:00pm - 1:00pm',
  },

  {
    id: 3,
    title: 'Pythagora’s theorem (I)',
    subtitle: 'History of Pythagora’s theorem',
    when: 'Today',
    time: '3:00pm - 4:00pm',
  },
];
